module.exports = __webpack_public_path__ + "static/transformer-for-cnc-machine-5a5e31bc3f331ce0073802e0236fd80a.jpg";